<template>
  <v-dialog
    v-if="!dialogVisibleCreateActivity"
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    content-class="content-create-template-dialog"
    @click:outside="closeDialog"
  >
    <v-card style="margin-top: -72px" color="background">
      <v-row no-gutters style="position: relative; top: 72px">
        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none ma-6"
          @click="show = false"
        >
          mdi-close
        </v-icon>
      </v-row>
      <v-row no-gutters>
        <v-col
          align="center"
          offset-sm="1"
          offset-md="1"
          :cols="mobile() ? '12' : '5'"
          :class="mobile() ? '' : ' pr-16 my-16'"
        >
          <v-card-title
            class="text-h5 font-weight-bold text-center justify-center mb-4 no-break"
          >
            {{ $t("requireAccount") }}
          </v-card-title>
          <v-card-subtitle
            class="text-body-1 darktext--text text-center d-none d-sm-block no-break mx-auto mx-xl-13"
            :style="
              $vuetify.breakpoint.name == 'xl' ||
              $vuetify.breakpoint.name == 'lg'
                ? 'height:150px'
                : 'height:190px'
            "
          >
            {{ $t("requireAccountText") }}
          </v-card-subtitle>

          <v-card-actions class="d-flex justify-center pb-4 pt-0">
            <v-btn
              ref="create"
              data-testid="create-button"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="requireMembers"
            >
            {{ action == 'edit' ? $t("update") : $t("create") }}
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-divider vertical />
        <v-col
          align="center"
          :cols="mobile() ? '12' : '5'"
          :class="mobile() ? '' : 'pl-16 my-16'"
        >
          <v-card-title
            class="text-h5 font-weight-bold text-center justify-center mb-4 no-break"
          >
            {{ $t("doNotRequireAccount") }}
          </v-card-title>
          <v-card-subtitle
            class="text-body-1 darktext--text text-center d-none d-sm-block no-break mx-auto mx-xl-13"
            :style="
              $vuetify.breakpoint.name == 'xl' ||
              $vuetify.breakpoint.name == 'lg'
                ? 'height:150px'
                : 'height:190px'
            "
          >
            {{ $t("doNotRequireAccountText") }}
          </v-card-subtitle>

          <v-card-actions class="d-flex justify-center pb-4 pt-0">
            <v-btn
              ref="create"
              data-testid="create-button-without"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="withoutMembers"
            >
              {{ action == 'edit' ? $t("update") : $t("create") }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";

export default {
  components: {},
  mixins: [repeatedMethodsMixin],
  props: {
    visible: Boolean,
    id: {
      type: Number,
      default: 0,
    },
    cdTitle: {
      type: String,
      default: "",
    },
    cdText: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dialogVisibleCreateActivity: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    requireMembers() {
      this.$emit("proceedSubmit", {"type":"participant", "action": this.action});
    },
    withoutMembers() {
      this.$emit("proceedSubmit", {"type":"email", "action": this.action});
    },

    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>
